import createIcon from '../../createIcon';

/**
 * @component @name LabelImportant
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDE4Ljk5TDE0LjUgMTlDMTUuMTcgMTkgMTUuNzcgMTguNjcgMTYuMTMgMTguMTZMMjAuNSAxMkwxNi4xMyA1Ljg0QzE1Ljc3IDUuMzMgMTUuMTcgNSAxNC41IDVMMy41IDUuMDFMOC4zNCAxMkwzLjUgMTguOTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LabelImportant = createIcon('LabelImportant', [
  [
    'path',
    {
      d: 'M3.5 18.99L14.5 19C15.17 19 15.77 18.67 16.13 18.16L20.5 12L16.13 5.84C15.77 5.33 15.17 5 14.5 5L3.5 5.01L8.34 12L3.5 18.99Z',
      key: '1w28w3',
    },
  ],
]);

export default LabelImportant;
